import React, { useEffect, useState } from "react";
import Web3 from "web3";
import { useAppKitAccount } from "@reown/appkit/react";
import { useConnectorClient } from "wagmi";

import { ITreasureContract } from "../config/contractConfig";
import ITreasureContractABI from "../abis/ITreasureContractABI.json";

import Nodata from "../assets/img/no-record-found.png";

import {
  FaHashtag,
  FaMoneyBillWave,
  FaClock,
} from "react-icons/fa";

const TradingHistory = () => {
  const { address, isConnected } = useAppKitAccount();
  const { data: client } = useConnectorClient();

  const [web3, setWeb3] = useState(null);
  const [tradeList, setTradeList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);

  const [totalTradeDays, setTotalTradeDays] = useState(0);
  const [totalTradeAmount, setTotalTradeAmount] = useState("0.00");


  const recordsPerPage = 10;

  // ================= INIT WEB3 =================
  useEffect(() => {
    if (!client && !window.ethereum) return;
    const provider = client?.transport || window.ethereum;
    setWeb3(new Web3(provider));
  }, [client]);

  // ================= FETCH DATA =================
  useEffect(() => {
    if (isConnected && address && web3) {
      fetchDayWiseTrade();
    }
  }, [isConnected, address, web3]);

 const fetchDayWiseTrade = async () => {
  try {
    const contract = new web3.eth.Contract(
      ITreasureContractABI,
      ITreasureContract
    );

    const res = await contract.methods
      .getUserDayWiseTradeData(address)
      .call();

    const tradedArr = res.traded || res[0];
    const amountArr = res.amounts || res[1];

    let list = [];
    let tradeDays = 0;
    let totalTradeAmount = 0; // ✅ normal number (ETH / USDT)

    for (let i = 0; i < tradedArr.length; i++) {
      const weiAmount = amountArr[i]?.toString() || "0";

      const etherAmount = Number(
        web3.utils.fromWei(weiAmount, "ether")
      );

      // ✅ SUMMARY
      if (tradedArr[i]) {
        tradeDays += 1;
        totalTradeAmount += etherAmount;
      }

      list.push({
        day: i + 1,
        traded: tradedArr[i],
        amount: etherAmount,
      });
    }

    // 🔥 latest day first
    setTradeList(list.reverse());

    // ✅ SUMMARY SET (same pattern as totalSelfPurchasing)
    setTotalTradeDays(tradeDays);
    setTotalTradeAmount(totalTradeAmount.toFixed(2));

  } catch (err) {
    console.error("❌ Trade fetch error:", err);

    setTradeList([]);
    setTotalTradeDays(0);
    setTotalTradeAmount("0.00");
  }
};


  // ================= PAGINATION =================
  const indexOfLast = currentPage * recordsPerPage;
  const indexOfFirst = indexOfLast - recordsPerPage;
  const currentRecords = tradeList.slice(indexOfFirst, indexOfLast);
  const totalPages = Math.ceil(tradeList.length / recordsPerPage);

  // ================= UI =================
  return (
    <div className="buyshheikh-page">
      <div className="pageTitle">
        <div className="section-title">
          <h2>
            <span className="text-warning"> Day Wise </span>{" "}
          <span className="fw-lighter"> Trading Report</span>
          </h2>
        </div>
      </div>

        {/* ✅ SUMMARY (PAGINATION KE UPAR, SAB PAGE PE SAME) */}
      <div className="card mt-3 mb-3">
        <div className="card-body d-flex justify-content-between flex-wrap gap-3">
          <div>
            <h6 className="text-white">Total Trade Days</h6>
            <h4 className="text-warning fw-bold">{totalTradeDays}</h4>
          </div>

          <div>
            <h6 className="text-white">Total Traded Amount</h6>
            <h4 className="text-warning fw-bold">
              {totalTradeAmount}{" "}
              <span>USDT</span>
            </h4>
          </div>
        </div>
      </div>

      <div className="mt-3">
        <div className="row">
          {currentRecords.length > 0 ? (
            currentRecords.map((item, index) => (
              <div className="col-md-4 mb-4" key={index}>
                <div className="ref-card">
                  <div className="ref-card-body">

                    {/* DAY */}
                    <div className="ref-row">
                      <span className="ref-label">
                        <FaHashtag className="ref-icon" /> Day
                      </span>
                      <span className="ref-value">{item.day}</span>
                    </div>

                    {/* TRADE STATUS */}
                    <div className="ref-row">
                      <span className="ref-label">
                        <FaClock className="ref-icon" /> Trade Status
                      </span>
                      <span
                        className={
                          item.traded
                            ? "text-success fw-semibold"
                            : "text-danger fw-semibold"
                        }
                      >
                        {item.traded ? "Traded" : "Not Traded"}
                      </span>
                    </div>

                    {/* AMOUNT */}
                    <div className="ref-row">
                      <span className="ref-label">
                        <FaMoneyBillWave className="ref-icon" /> Amount
                      </span>

                      {item.traded ? (
                        <span className="ref-badge">
                          {Number(item.amount).toFixed(2)}{" "}
                          <span style={{ color: "#26a17b", fontWeight: 600 }}>
                            USDT
                          </span>
                        </span>
                      ) : (
                        <span className="">
                          <b className="text-warning me-1">  0.00  </b>
                          <span style={{ color: "#26a17b", fontWeight: 600 }}>
                            USDT
                          </span>
                        </span>
                      )}
                    </div>

                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="no-data">
              <img src={Nodata} alt="No Data" />
            </div>
          )}
        </div>

        {/* PAGINATION */}
        {totalPages > 1 && (
          <div className="pagination-div">
            <ul className="pagination mb-0">
              {[...Array(totalPages)].map((_, idx) => (
                <li
                  key={idx}
                  className={`page-item ${
                    currentPage === idx + 1 ? "active" : ""
                  }`}
                >
                  <button
                    className="page-link"
                    onClick={() => setCurrentPage(idx + 1)}
                  >
                    {idx + 1}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
};

export default TradingHistory;
